Vue.component("carousel-legend", {

    template: `<div class="row">
        <div class="col-12 col-lg-12" v-if="!disableCarousel">
            <div class="list-item-carousel owl-carousel owl-theme owl-single-item" ref="carouselContainer">
                <slot-component v-for="(item, index) in $slots.items" :key="index" :vnode="item" />
            </div>
        </div>

        <div class="col-12" v-else>
            <div class="carousel-flex" :class="columnWidths">
                <div class="column" v-for="item in $slots.items">
                    <slot-component :vnode="item"/>
                </div>
            </div>
        </div>
    </div>
    `,

    components: {
        SlotComponent: {
            functional: true,
            render: (createElement, context) => context.data.attrs.vnode
        }
    },

    props: {
        itemsPerPage:
        {
            type: Number,
            default: 5
        },
        itemsPerPageXs:
        {
            type: Number,
            default: 1
        },
        itemsPerPageSm:
        {
            type: Number,
            default: 2
        },
        itemsPerPageMd:
        {
            type: Number,
            default: 3
        },
        itemsPerPageLg:
        {
            type: Number,
            default: 4
        },
        disableCarousel:
        {
            type: Boolean,
            default: false
        }
    },

    computed:
    {
        columnWidths()
        {
            return [
                "col-xs-w-"+this.itemsPerPageXs,
                "col-sm-w-"+this.itemsPerPageSm,
                "col-md-w-"+this.itemsPerPageMd,
                "col-lg-w-"+this.itemsPerPageLg,
                "col-xl-w-"+this.itemsPerPage
            ];
        }
    },

    mounted()
    {
        this.$nextTick(() =>
        {
            this.initializeCarousel();
        });
    },

    updated()
    {
        this.initializeCarousel();
    },

    methods:
    {
        initializeCarousel()
        {
            if (this.$slots.items)
            {
                const $owl = $(this.$refs.carouselContainer);

                // do not render, if no html element is inside of the carousels container
                if (!$owl.children().length)
                {
                    return;
                }

                $owl.owlCarousel({
                    onInitialized()
                    {
                        $owl.find(".owl-carousel.owl-loaded").each(function()
                        {
                            $(this).trigger("refresh.owl.carousel");
                        });
                    },
                    autoHeight       : true,
                    dots             : true,
                    items            : this.itemsPerPage,
                    responsive: {
                        0:   { items: this.itemsPerPageXs },
                        576: { items: this.itemsPerPageSm },
                        768: { items: this.itemsPerPageMd },
                        992: { items: this.itemsPerPageLg },
                        1200: { items: this.itemsPerPage }
                    },
                    lazyLoad: false,
                    loop: false,
                    margin: 30,
                    mouseDrag: true,
                    nav: true,
                    navClass: [
                        "owl-single-item-nav left carousel-control list-control-special",
                        "owl-single-item-nav right carousel-control list-control-special"
                    ],
                    navContainerClass: "",
                    navText: [
                        "<i class=\"owl-single-item-control fa fa-chevron-left\" aria-hidden=\"true\"></i>",
                        "<i class=\"owl-single-item-control fa fa-chevron-right\" aria-hidden=\"true\"></i>"
                    ],
                    smartSpeed: 350
                });
            }
        }
    }
});
